import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_API_DSN,
  integrations: [Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.NODE_ENV,
});

window.onerror = function (message, source, lineno, colno, error) {
  Sentry.captureException(error || new Error(message as string));
};

window.addEventListener("unhandledrejection", (event) => {
  Sentry.captureException(event.reason);
});